module.exports = __webpack_public_path__ + "static/Body-26d7f1e3d14704b6223d32b334fd0f3b.png";